import rg4js from 'raygun4js';

rg4js('enableCrashReporting', true);
rg4js('apiKey', process.env.REACT_APP_RAYGUN_API_KEY);
rg4js('options', { disableAnonymousUserTracking: true });

export const setUser = ({ Email, FirstName, LastName }) => {
  rg4js('setUser', {
    identifier: Email,
    firstName: FirstName,
    fullName: `${FirstName} ${LastName}`,
    isAnonymous: false
  });
};



// WEBPACK FOOTER //
// ./src/utils/raygun.js